import DepositAccountSettings from '@/models/Accounts/DepositAccounts/Settings/DepositAccountSettings';
import DepositAccountValues from '@/models/Accounts/DepositAccounts/Values/DepositAccountValues';
import Amount from "@/models/Shared/Amount";
import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";
import DepositAccountPaymentInterface from "@/models/Accounts/DepositAccounts/DepositAccountPaymentInterface";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class DepositAccountSummary {
    accountNumber: string;
    accountSettings: DepositAccountSettings;
    accountValues: DepositAccountValues;
    availableBalance: Amount = new Amount();
    balance: Amount = new Amount();
    bic: string;
    createdAt: string;
    customerId: string;
    customerIdentifier: EntityIdentifier;
    defaultCurrency: string;
    defaultWalletId: string;
    enabled: boolean;
    iban: string;
    id: string;
    name: string;
    paymentInterfaces: DepositAccountPaymentInterface[] = [];
    productId: string;
    productIssueId: string;
    productName: string;
    productSubType: string;
	productType: string;
    reviewDateUtc: Date;
    state: string;
    sortCode: string;
    updatedAt: string;
    wallets: Wallet[] = [];
}